import React from 'react';
import { Divider, Form } from '@roo/roo';
import styled from 'styled-components';
import { get } from 'lodash';
import { saveStudyInfo } from '@assets/apis/scientist';
import { requiredRule } from '@utils/rules';
import { cols } from '../../_utils/config';
import { useSimpleContext } from '../../_context';
import { FormHok } from '../../_components/FormHok';
import Area from './area';
import Topic from './topic';
import Paper from './paper';
import Authority from './authority';

const { Field } = Form;

const Root = styled.div`
  .form-patch {
    margin-top: 8px;
    width: 634px;
  }
  .form-group {
    & > label {
      text-align: left;
    }
  }
  .field-upload {
    margin-left: 12px;
  }
  .boffin {
    position: relative;
    .delete {
      position: absolute;
      top: -10px;
      right: 100px;
    }
  }
`;

// 附加信息
const StudyInfo = function ({ setStep }) {
  const { state } = useSimpleContext((t) => [t.scientist.iniValues, t.disabled]);
  return (
    <FormHok
      value={state.scientist.iniValues?.studyInfo}
      cols={cols}
      disabled={state.disabled}
      alwaysUpdate={false}
      handleSave={saveStudyInfo}
    >
      {(props) => (
        <Root className="boffin">
          <div className="form-title">
            申报人所属学科领域
            <Divider />
          </div>
          <div className="form-patch">
            <Field
              required
              label="学科领域"
              name="studyArea"
              rule={{
                validator: (rule, value1, callback) => {
                  const value = (get(props, 'values.studyArea') || []).filter(Boolean);
                  const type = get(props, 'values.studyAreaType');
                  if (type === value.length && [1, 2].includes(type)) {
                    return callback();
                  }
                  callback('请选择学科领域');
                },
              }}
              as={<Area {...props} type={props.values?.studyAreaType} studyAreaPath={props.values?.studyAreaPath} />}
            />
          </div>
          <div className="form-title">
            领域内权威专家
            <span>最多可填写两位专家</span>
            <Divider />
          </div>
          <Authority {...props} />
          <div className="form-title">
            科研议题
            <Divider />
          </div>
          <div className="form-patch" style={{ width: 672 }}>
            <Field
              required
              label="相关议题"
              layout="vertical"
              name="studyIssues"
              rule={{ ...requiredRule, type: 'array' }}
            >
              {(props) => <Topic {...props} />}
            </Field>
          </div>
          <div className="form-title">
            学术成果
            <Divider />
          </div>
          <Paper {...props} />
          <br />
        </Root>
      )}
    </FormHok>
  );
};
export default StudyInfo;
